import { paths } from "../../app/paths";
import { StatusPage } from "./StatusPage";

/**
 * Shown in place of a page the user's roles don't allow. Deliberately does not list the
 * missing permissions: that detail helps an attacker map the system more than it helps a user.
 */
export function ForbiddenPage() {
  return (
    <StatusPage
      code="Error 403"
      title="You don't have access to this page"
      action={{ href: paths.home, label: "Go to the home page" }}
    >
      <p>
        Your account's role doesn't include this area. If you need it for your work, ask your
        organization administrator to update your role.
      </p>
    </StatusPage>
  );
}
